import { Component, ViewChild, OnInit } from "@angular/core";
import { MatSidenav } from "@angular/material/sidenav";
import { NavigationEnd, Router } from "@angular/router";
import { BrowserStorage } from "../core/storage";
import { ModalHandler } from "../core/modal-handler";
import { AuthService } from "../services/auth.service";
import { PortalService } from "../services/portal-service.service";
import { ShellService } from "../services/shell.service";
import { ThemeService } from "../services/theme.service";
import { filter } from "rxjs";
import packageJson from "../../../package.json";

@Component({
  templateUrl: "./shell.component.html",
  styleUrls: ["./shell.component.scss"],
  providers: [],
  standalone: false,
})
export class ShellComponent implements OnInit {
  @ViewChild(MatSidenav) sidenav: MatSidenav;

  shellService: ShellService;
  doingStuff = true;
  isSidenavPinned = false;
  year = new Date().getFullYear().toString();
  version = packageJson.version;

  constructor(
    private router: Router,
    private as: AuthService,
    private ss: ShellService,
    private mh: ModalHandler,
    private ps: PortalService,
    private ts: ThemeService,
  ) {
    this.shellService = this.ss;
  }

  ngOnInit(): void {
    this.isSidenavPinned = BrowserStorage.getBoolean("shell.sidenav.pinned", true, false) ?? true;
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => this.syncContractFromUrl());
    this.ss.populateInterface().then(() => {
      this.doingStuff = false;
      this.syncContractFromUrl();
      if (this.router.url === "/" || this.router.url === "/login") this.router.navigate(["/home"]);
    });
  }

  toggleSidenav(): void {
    if (this.isSidenavPinned) {
      this.blurMenuButton();
      return;
    }

    this.sidenav.toggle();
    this.blurMenuButton();
  }

  toggleSidenavPin(): void {
    this.isSidenavPinned = !this.isSidenavPinned;
    BrowserStorage.setBoolean("shell.sidenav.pinned", this.isSidenavPinned, false);

    if (this.isSidenavPinned) this.sidenav.open();
    else this.sidenav.close();
  }

  closeNavAfterRoute(): void {
    if (!this.isSidenavPinned) this.sidenav.close();
  }

  changeContract(contractId: number | null): void {
    this.ss.setSelectedContract(contractId);
    const isDownloadsRoute = this.router.url.includes("/downloads");
    this.router.navigate([], {
      queryParams: isDownloadsRoute ? { contract: null } : { contract: contractId },
      queryParamsHandling: "merge",
    });
  }

  private syncContractFromUrl(): void {
    const queryParams = this.router.parseUrl(this.router.url).queryParams;
    const contractId = Number(queryParams["contract"]);
    if (contractId) this.ss.setSelectedContract(contractId);
  }

  private blurMenuButton(): void {
    const menuButton = document.getElementById("menu-button");
    if (menuButton) menuButton.blur();
  }

  setTheme(theme: string): void {
    this.ts.setTheme(theme);
  }

  logout(): void {
    this.ss.resetInterface();
    this.as.logout();
    this.router.navigate(["/login"]);
  }

  get light(): boolean {
    return ThemeService.getTheme() === "light";
  }

  get classic(): boolean {
    return ThemeService.getTheme() === "classic";
  }

  get canActivateLicences(): boolean {
    const contract = this.shellService.selectedContract;
    return !!contract && !this.ps.disableActivateTab(contract);
  }

  get canSurrenderLicences(): boolean {
    const contract = this.shellService.selectedContract;
    return !!contract && !this.ps.disableSurrenderTab(contract);
  }

  get canRequestTokens(): boolean {
    const contract = this.shellService.selectedContract;
    return !!contract && !this.ps.disableTokenTab(contract);
  }

  get isTrialUser(): boolean {
    return !!this.as.JWTDecode(this.as.getToken()).trial;
  }
}
